import { render, staticRenderFns } from "./UserOrPosDialog.vue?vue&type=template&id=0cfeb192"
import script from "./UserOrPosDialog.vue?vue&type=script&lang=js"
export * from "./UserOrPosDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports